<template>
  <div v-if="inputValue">
    <MasterMultipleAreaBase
      v-model="inputValue"
      :title="
        $t('common.common_storage') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
      :pageData="pageData"
      @complete="complete()"
      @clicksubTextButton="addStorageRecipientInputForm()"
    >
      <template v-slot:[pageData[0].name]>
        <v-container fluid class="pa-0">
          <v-row no-gutters class="mx-10 my-3">
            <v-col cols="5" class="mr-16">
              <InputFormNew
                v-model="inputData.storageInfoLine1"
                :detail="items.storageInfoLine1"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              />
            </v-col>
            <v-col cols="5"> </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:[pageData[1].name]>
        <v-container fluid class="pa-0">
          <v-row
            v-if="!inputData.storageRecipientList.length"
            no-gutters
            class="ma-7"
          >
            <v-col class="text-center">{{
              $t('user.user_recipient-is-not-set')
            }}</v-col>
          </v-row>
          <li
            v-for="storageRecipientItem in inputData.storageRecipientList"
            :key="storageRecipientItem.storageRecipientId"
          >
            <v-row no-gutters class="ml-10">
              <v-col cols="5" class="mr-16">
                <InputFormNew
                  v-model="storageRecipientItem.storageRecipientInfoLine1"
                  :detail="items.storageRecipientInfoLine1"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                />
              </v-col>
              <v-col cols="5" class="mr-10">
                <InputFormNew
                  v-model="storageRecipientItem.storageRecipientInfoLine2"
                  :detail="items.storageRecipientInfoLine2"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                >
                  <!-- 郵便番号 -->
                  <template #storageRecipientPostalCode="{ item }">
                    <PostalCodeArea
                      v-model="item.storageRecipientPostalCode"
                      :height="inputFormStyle.inputItemHeight"
                      :countryId="item.country.value"
                      @click="
                        getAddressFromStorageRecipientPostalCode($event, item)
                      "
                    />
                  </template>
                </InputFormNew>
              </v-col>
              <v-col class="deleteItemCol d-flex justify-center align-center">
                <div class="">
                  <NormalTextButton
                    :text="$t('common.input_delete')"
                    @click.native="
                      deleteStorageRecipientInfo(storageRecipientItem)
                    "
                  />
                </div>
              </v-col>
            </v-row>
            <v-divider> </v-divider>
          </li>
        </v-container>
      </template>
    </MasterMultipleAreaBase>
  </div>
</template>
<script>
import MasterMultipleAreaBase from '../MasterMultipleAreaBase'
import {
  InputFormNew,
  NormalTextButton,
  PostalCodeArea
} from '@/components/items'
import { mapActions, mapGetters } from 'vuex'
import { countryCallingCodeUtil, countryUtil } from '@/util'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    MasterMultipleAreaBase,
    InputFormNew,
    NormalTextButton,
    PostalCodeArea
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    storageData: {
      type: Object,
      require: false,
      default: () => ({
        storageRecipients: []
      })
    },
    editMode: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  data: () => ({
    pageData: [],
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 9,
      inputItemHeight: '32px'
    },
    inputData: {},
    items: {
      storageInfoLine1: [
        {
          name: 'storageName',
          text: 'product.product_storage-name',
          required: true
        },
        {
          name: 'isEnabled',
          text: 'product.product_display-setting',
          component: 'CheckEnabled'
        }
      ],
      storageRecipientInfoLine1: [
        {
          name: 'storageRecipientName',
          text: 'common.input_name',
          required: true
        },
        {
          name: 'storageRecipientPhone',
          text: 'common.input_phone-number',
          required: true,
          component: 'PhoneNumberInput'
        },
        {
          name: 'storageRecipientNote',
          text: 'product.product_memo'
        }
      ],
      storageRecipientInfoLine2: [
        {
          name: 'country',
          text: 'common.input_country',
          cols: Math.ceil(5),
          required: true,
          component: 'SelectCountry'
        },
        {
          name: 'storageRecipientPostalCode',
          text: 'common.input_postal-code',
          cols: Math.ceil(5)
        },
        {
          name: 'storageRecipientRegion',
          text: 'common.input_region',
          cols: Math.ceil(5),
          required: true,
          component: 'SelectRegion'
        },
        {
          name: 'storageRecipientAddress1',
          text: 'common.input_address_1',
          required: true
        },
        {
          name: 'storageRecipientAddress2',
          text: 'common.input_address_2'
        }
      ]
    }
  }),

  methods: {
    ...mapActions('Storage', ['registerEditStorage']),
    ...mapGetters('Common', [
      'getCountryCallingCodeJpFromState',
      'getCountryJpFromState'
    ]),
    ...mapActions('Common', ['getCountryListFromApi']),

    setCountryCallingCode(countryId) {
      return this.editMode
        ? countryCallingCodeUtil.getPhoneNumberInfoById(countryId)
        : this.getCountryCallingCodeJpFromState()
    },
    setCountryId(countryId) {
      return this.editMode
        ? countryUtil.getCountryIdInfo(countryId)
        : this.getCountryJpFromState()
    },
    // 受取人の郵便番号自動入力
    getAddressFromStorageRecipientPostalCode(address, storageRecipientInfo) {
      storageRecipientInfo.storageRecipientRegion =
        countryUtil.getRegionInfoByName(
          storageRecipientInfo.country.value,
          address.region
        )
      storageRecipientInfo.storageRecipientAddress1 = address.locality
      storageRecipientInfo.storageRecipientAddress2 = address.street
    },
    async init() {
      const formatData = _cloneDeep(this.storageData)
      // 新規登録の際に「表示する」項目のダイアログ初期値をtrueで設定
      if (Object.keys(formatData).length === 1) {
        formatData.isEnabled = true
      }
      // storageRecipientsをフォーマットした新たな配列を作成
      if (this.storageData.storageRecipients) {
        formatData.storageRecipients = this.storageData.storageRecipients.map(
          (ele) => {
            return {
              storageRecipientId: ele.storageRecipientId,
              name: ele.name,
              note: ele.note,
              postalCode: ele.postalCode,
              address1: ele.address1,
              address2: ele.address2,
              storageRecipientPhone: {
                countryCode: this.setCountryCallingCode(
                  ele.phoneNumberCountryId
                ),
                phoneNumber: ele.phoneNumber
              },
              storageRecipientAddressCountry: this.setCountryId(ele.countryId),
              storageRecipientRegion: countryUtil.getRegionInfo(
                ele.countryId,
                ele.regionId
              )
            }
          }
        )
      }
      // InputFormNewコンポーネントを使用できるようにline1,line2に入力フォームを分けて設定
      const formatStorageRecipientList = formatData.storageRecipients
        ? formatData.storageRecipients.map((ele) => {
            return {
              storageRecipientInfoLine1: {
                storageRecipientName: ele.name,
                storageRecipientPhone: ele.storageRecipientPhone,
                storageRecipientNote: ele.note
              },
              storageRecipientInfoLine2: {
                country: ele.storageRecipientAddressCountry,
                storageRecipientPostalCode: ele.postalCode,
                storageRecipientRegion: ele.storageRecipientRegion,
                storageRecipientAddress1: ele.address1,
                storageRecipientAddress2: ele.address2
              }
            }
          })
        : []

      this.inputData = {
        storageId: formatData.storageId,
        storageInfoLine1: {
          storageName: formatData.name,
          isEnabled: formatData.isEnabled
        },
        storageRecipientList: formatStorageRecipientList
      }

      this.pageData = [
        {
          title: 'product.product_storage-info',
          name: 'customerInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'common.input_recipient-list',
          name: 'storageRecipientInfo',
          subText: 'common.input_add-recipient',
          items: [],
          itemKey: ''
        }
      ]
    },
    async complete() {
      if (this.editMode) {
        this.inputData.mode = 'edit'
      }
      const success = await this.registerEditStorage(this.inputData)

      if (success) {
        // 都道府県がStringで追加された場合用に国マスタを再度取得
        this.getCountryListFromApi()
        this.$emit('success')
      }
    },
    // 受取人追加ボタンの処理
    addStorageRecipientInputForm() {
      this.inputData.storageRecipientList.push({
        storageRecipientInfoLine1: {
          storageRecipientName: null,
          storageRecipientPhone: {
            countryCode: this.getCountryCallingCodeJpFromState(),
            phoneNumber: null
          },
          storageRecipientNote: null
        },
        storageRecipientInfoLine2: {
          country: this.getCountryJpFromState(),
          storageRecipientPostalCode: null,
          storageRecipientRegion: countryUtil.getRegionInfo(null),
          storageRecipientAddress1: null,
          storageRecipientAddress2: null
        }
      })
    },
    // 受取人削除ボタンの処理
    deleteStorageRecipientInfo(storageRecipientItem) {
      this.inputData.storageRecipientList =
        this.inputData.storageRecipientList.filter((storageRecipient) => {
          return storageRecipient != storageRecipientItem
        })
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.deleteItemCol {
  border-left: 1px solid #d8d8d8;
}
</style>
